import { gssDatasets } from "@/config/gssDatasets";

const routes = [
  // Nouvelle route unique centralisée
  {
    path: "/rapport-mail-auto-prog",
    name: "auto-email-report-prog",
    component: () =>
      import("@/views/pages/admin/auto-email-report/RapportMailAutoProg.vue"),
    meta: {
      layout: "content",
      resource: "programmatique",
      action: "manage",
      rmrAnalytics: {
        track: true,
        eventType: "auto-email-report-prog",
        eventCategory: "page-view",
      },
    },
  },

  // Redirection rétrocompatible pour l'ancienne route Acteurs & Périmètres
  {
    path: "/rapport-mail-auto-prog/acteurs-perimetre",
    name: "auto-email-report-actors-perimeter",
    meta: {
      resource: "programmatique",
      action: "manage",
    },
    redirect: (to) => ({
      path: "/rapport-mail-auto-prog",
      query: { ...to.query, tab: "config" },
    }),
  },

  // Redirection racine pour l'accès direct à /donnees sans sous-chemin
  {
    path: "/rapport-mail-auto-prog/donnees",
    meta: {
      resource: "programmatique",
      action: "manage",
    },
    redirect: (to) => ({
      path: "/rapport-mail-auto-prog",
      query: { ...to.query, tab: "donnees", dataset: "obj" },
    }),
  },

  // Redirections rétrocompatibles pour chaque ancien onglet GSS (avec préservation des noms de routes)
  ...gssDatasets.map((ds) => ({
    path: `/rapport-mail-auto-prog/donnees/${ds.path}`,
    name: ds.to,
    meta: {
      resource: "programmatique",
      action: "manage",
    },
    redirect: (to) => ({
      path: "/rapport-mail-auto-prog",
      query: { ...to.query, tab: "donnees", dataset: ds.id },
    }),
  })),

  // Fallback dynamique pour les anciennes URLs /donnees/:datasetPath
  {
    path: "/rapport-mail-auto-prog/donnees/:datasetPath",
    meta: {
      resource: "programmatique",
      action: "manage",
    },
    redirect: (to) => {
      const match = gssDatasets.find(
        (ds) => ds.path === to.params.datasetPath || ds.id === to.params.datasetPath
      );
      return {
        path: "/rapport-mail-auto-prog",
        query: {
          ...to.query,
          tab: "donnees",
          dataset: match ? match.id : "obj",
        },
      };
    },
  },
];

export default routes;

